export const FETCH_RANKED_ROUNDS = "FETCH_RANKED_ROUNDS";
export const FETCH_RANKED_ROUNDS_SUCCESS = "FETCH_RANKED_ROUNDS_SUCCESS";
export const FETCH_RANKED_ROUNDS_FAILURE = "FETCH_RANKED_ROUNDS_FAILURE";

export const SUBMIT_RANKED_BOOKING = "SUBMIT_RANKED_BOOKING";
export const SUBMIT_RANKED_BOOKING_SUCCESS = "SUBMIT_RANKED_BOOKING_SUCCESS";
export const SUBMIT_RANKED_BOOKING_FAILURE = "SUBMIT_RANKED_BOOKING_FAILURE";

export const FETCH_LEADERBOARD = "FETCH_LEADERBOARD";
export const FETCH_LEADERBOARD_SUCCESS = "FETCH_LEADERBOARD_SUCCESS";
export const FETCH_LEADERBOARD_FAILURE = "FETCH_LEADERBOARD_FAILURE";

export const FETCH_USER_PREDICTIONS = "FETCH_USER_PREDICTIONS";
export const FETCH_USER_PREDICTIONS_SUCCESS = "FETCH_USER_PREDICTIONS_SUCCESS";
export const FETCH_USER_PREDICTIONS_FAILURE = "FETCH_USER_PREDICTIONS_FAILURE";

export const FETCH_CURRENT_RANKED_ROUND = "FETCH_CURRENT_RANKED_ROUND";
export const FETCH_CURRENT_RANKED_ROUND_SUCCESS = "FETCH_CURRENT_RANKED_ROUND_SUCCESS";
export const FETCH_CURRENT_RANKED_ROUND_FAILURE = "FETCH_CURRENT_RANKED_ROUND_FAILURE";

export const FETCH_RANKED_BOOKINGS_LEADERBOARD = "FETCH_RANKED_BOOKINGS_LEADERBOARD";
export const FETCH_RANKED_BOOKINGS_LEADERBOARD_SUCCESS = "FETCH_RANKED_BOOKINGS_LEADERBOARD_SUCCESS";
export const FETCH_RANKED_BOOKINGS_LEADERBOARD_FAILURE = "FETCH_RANKED_BOOKINGS_LEADERBOARD_FAILURE";
